import PayrollMonthPage from './payroll/[month]';

export default function Payslip() {
  return (
    <PayrollMonthPage />
  );
}
